'use client';

import { cn } from '@/lib/utils';
import type { Company } from '@/types/content';
import { MailCheck, MapPin } from 'lucide-react';
import Link from '../ui/Link';

export default function CompanyDetailsView({
    company,
    className,
}: {
    company: Company;
    className?: string;
}) {
    return (
        <div className={cn('flex flex-col space-y-4 max-lg:space-y-2', className)}>
            <div className="flex items-center text-h5 max-lg:text-p">
                <MapPin
                    className="mr-12 min-h-4 min-w-4 max-lg:mr-3 max-xl:mr-4"
                    width={16}
                    height={20}
                />
                <Link href={company.geo} target="_blank" title={company.address} />
            </div>
            <div className="flex items-center text-h5 max-lg:text-p">
                <MailCheck
                    className="mr-12 min-h-4 min-w-4 max-lg:mr-3 max-xl:mr-4"
                    width={16}
                    height={20}
                />
                <div className="w-fit flex flex-wrap">
                    <Link
                        className="whitespace-nowrap"
                        href={`mailto:${company.email}`}
                        target="_blank"
                        title={company.email}
                    />
                    ,&nbsp;
                    <Link
                        className="whitespace-nowrap"
                        href={`tel:${company.phone}`}
                        target="_blank"
                        title={company.phone}
                    />
                </div>
            </div>
        </div>
    );
}
